/* GELÉE theme.js – vanilla, no dependencies */
(() => {
  const G = window.GELEE || {};
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));

  /* Announcement rotator (mobile) */
  $$('[data-rotator]').forEach(track => {
    const items = $$('.announcement__item', track);
    if (items.length < 2) return;
    let i = 0;
    setInterval(() => {
      if (window.matchMedia('(min-width: 990px)').matches) return;
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, 3800);
  });

  /* Drawers */
  let lastFocus = null;
  const openDrawer = id => {
    const d = document.getElementById(id);
    if (!d) return;
    lastFocus = document.activeElement;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    const f = $('button, a, input', $('.drawer__panel', d));
    f && setTimeout(() => f.focus(), 60);
  };
  const closeDrawers = () => {
    $$('[data-drawer].is-open').forEach(d => { d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); });
    document.documentElement.style.overflow = '';
    lastFocus && lastFocus.focus && lastFocus.focus();
  };
  document.addEventListener('click', e => {
    const opener = e.target.closest('[data-open-drawer]');
    if (opener) { e.preventDefault(); openDrawer(opener.dataset.openDrawer); return; }
    const cartOpener = e.target.closest('[data-open-cart]');
    if (cartOpener && G.cartType === 'drawer' && document.getElementById('cart-drawer')) { e.preventDefault(); openDrawer('cart-drawer'); return; }
    if (e.target.closest('[data-close-drawer]')) { e.preventDefault(); closeDrawers(); }
  });
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeDrawers(); });

  /* Cart */
  const updateCount = count => $$('[data-cart-count]').forEach(el => { el.textContent = count > 0 ? count : ''; });
  const renderDrawer = html => {
    const old = document.getElementById('cart-drawer');
    if (!old || !html) return;
    const tmp = document.createElement('div');
    tmp.innerHTML = html;
    const fresh = tmp.querySelector('#cart-drawer');
    if (!fresh) return;
    const wasOpen = old.classList.contains('is-open');
    old.replaceWith(fresh);
    if (wasOpen) { fresh.classList.add('is-open'); fresh.setAttribute('aria-hidden', 'false'); }
  };
  const refreshCount = () => fetch(G.routes.cart + '.js').then(r => r.json()).then(c => updateCount(c.item_count)).catch(() => {});

  const addToCart = async (form, btn) => {
    const errorEl = $('[data-form-error]', form);
    if (errorEl) errorEl.hidden = true;
    btn && btn.classList.add('is-loading');
    const fd = new FormData(form);
    if (G.cartType === 'drawer') { fd.append('sections', 'cart-drawer'); fd.append('sections_url', window.location.pathname); }
    try {
      const res = await fetch(G.routes.cart_add + '.js', { method: 'POST', body: fd, headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' } });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || G.strings.error);
      if (G.cartType !== 'drawer') { window.location.href = G.routes.cart; return; }
      if (data.sections) renderDrawer(data.sections['cart-drawer']);
      await refreshCount();
      openDrawer('cart-drawer');
    } catch (err) {
      if (errorEl) { errorEl.textContent = err.message; errorEl.hidden = false; } else { alertFallback(err.message); }
    } finally { btn && btn.classList.remove('is-loading'); }
  };
  const alertFallback = msg => { const n = document.createElement('div'); n.className = 'form-msg form-msg--error'; n.style.cssText = 'position:fixed;left:16px;right:16px;bottom:16px;z-index:200'; n.textContent = msg; document.body.appendChild(n); setTimeout(() => n.remove(), 4000); };

  document.addEventListener('submit', e => {
    const form = e.target;
    if (form.matches('[data-product-form]') || form.matches('[data-quick-add]')) {
      e.preventDefault();
      const btn = form.querySelector('[type="submit"]') || e.submitter;
      addToCart(form, form.matches('[data-product-form]') ? $('[data-atc]', form) : btn);
    }
  });

  const changeLine = async (line, quantity) => {
    const onCartPage = !!$('[data-cart-page]');
    const body = { line, quantity };
    if (!onCartPage && G.cartType === 'drawer') { body.sections = ['cart-drawer']; body.sections_url = window.location.pathname; }
    const res = await fetch(G.routes.cart_change + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
    const data = await res.json();
    if (onCartPage) { window.location.reload(); return; }
    if (data.sections) renderDrawer(data.sections['cart-drawer']);
    updateCount(data.item_count);
  };
  document.addEventListener('click', e => {
    const b = e.target.closest('[data-change]');
    if (!b) return;
    const row = b.closest('[data-line]');
    if (!row) return;
    e.preventDefault();
    row.style.opacity = '.5';
    changeLine(parseInt(row.dataset.line, 10), Math.max(0, parseInt(b.dataset.change, 10))).catch(() => { row.style.opacity = ''; });
  });
  document.addEventListener('change', e => {
    const input = e.target.closest('[data-qty-input]');
    if (!input) return;
    const row = input.closest('[data-line]');
    row && changeLine(parseInt(row.dataset.line, 10), Math.max(0, parseInt(input.value, 10) || 0));
  });

  /* PDP quantity */
  document.addEventListener('click', e => {
    const b = e.target.closest('[data-qty]');
    if (!b) return;
    const input = b.parentElement.querySelector('input');
    input.value = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(b.dataset.qty, 10));
  });

  /* Variant select */
  $$('[data-variant-select]').forEach(sel => {
    sel.addEventListener('change', () => {
      const opt = sel.selectedOptions[0];
      const form = document.getElementById(sel.getAttribute('form'));
      if (form) $('[data-variant-id]', form).value = sel.value;
      const priceNow = $('[data-price-wrap] .price__now');
      if (priceNow && opt.dataset.price) priceNow.textContent = opt.dataset.price;
      const sp = $('[data-sticky-price]');
      if (sp && opt.dataset.price) sp.textContent = opt.dataset.price;
      const url = new URL(window.location.href); url.searchParams.set('variant', sel.value);
      history.replaceState({}, '', url);
    });
  });

  /* Gallery dots */
  $$('[data-gallery]').forEach(g => {
    const track = $('[data-gallery-track]', g);
    const dots = $$('[data-gallery-dots] button', g);
    if (!track || !dots.length) return;
    track.addEventListener('scroll', () => {
      const i = Math.round(track.scrollLeft / track.clientWidth);
      dots.forEach((d, j) => d.classList.toggle('is-active', i === j));
    }, { passive: true });
    dots.forEach((d, j) => d.addEventListener('click', () => track.scrollTo({ left: j * track.clientWidth, behavior: 'smooth' })));
  });

  /* Sticky add to cart */
  const atc = $('[data-atc]');
  const sticky = $('[data-sticky-atc]');
  if (atc && sticky && 'IntersectionObserver' in window) {
    new IntersectionObserver(([en]) => {
      const show = !en.isIntersecting && en.boundingClientRect.top < 0;
      sticky.classList.toggle('is-visible', show);
      sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
    }).observe(atc);
  }

  /* Delivery estimate (business days, Mon–Fri) */
  $$('[data-delivery]').forEach(el => {
    const addBiz = (d, n) => { const r = new Date(d); while (n > 0) { r.setDate(r.getDate() + 1); const w = r.getDay(); if (w !== 0 && w !== 6) n--; } return r; };
    const fmt = d => d.toLocaleDateString(G.locale === 'en' ? 'en-GB' : 'de-DE', { weekday: 'short', day: '2-digit', month: '2-digit' });
    const now = new Date();
    const a = addBiz(now, parseInt(el.dataset.min, 10)); const b = addBiz(now, parseInt(el.dataset.max, 10));
    const t = $('[data-delivery-text]', el);
    if (t) t.innerHTML = (G.locale === 'en' ? 'Delivery between ' : 'Lieferung zwischen ') + '<strong>' + fmt(a) + '</strong>' + (G.locale === 'en' ? ' and ' : ' und ') + '<strong>' + fmt(b) + '</strong>';
  });

  /* Collection sort */
  $$('[data-sort]').forEach(s => s.addEventListener('change', () => { const u = new URL(window.location.href); u.searchParams.set('sort_by', s.value); u.searchParams.delete('page'); window.location.href = u; }));

  /* Reveal on scroll */
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver(es => es.forEach(en => { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } }), { rootMargin: '0px 0px -8% 0px' });
    $$('.reveal').forEach(el => io.observe(el));
  } else { $$('.reveal').forEach(el => el.classList.add('is-in')); }
})();
